import React, { forwardRef, Ref } from 'react';
import { AriaFocusProps } from '../../types/common';
import { DropdownInput as DropdownInputNew } from './DropdownInput';
import { convertOldDropdownInputProps } from './converter.old';
import type { OldDropdownInputProps } from './converter.old';

export type DropdownInputProps<OptionValue> = OldDropdownInputProps<OptionValue>;

function DropdownInputInner<OptionValue extends string | number>(
  props: DropdownInputProps<OptionValue> & AriaFocusProps,
  ref: Ref<HTMLInputElement>,
) {
  return <DropdownInputNew {...convertOldDropdownInputProps(props)} ref={ref} />;
}

export const DropdownInput = forwardRef(DropdownInputInner) as (<OptionValue extends string | number>(
  props: DropdownInputProps<OptionValue> & AriaFocusProps & { ref?: Ref<HTMLInputElement> },
) => JSX.Element) & { displayName?: string };

DropdownInput.displayName = 'DropdownInput';
